import * as React from 'react'
import { SVGProps } from 'react'

const SvgYellowStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.618 5.465a.994.994 0 0 0-.926-.654H9.317a.364.364 0 0 1-.33-.196l-1.06-3.142A.995.995 0 0 0 7.001.82a.995.995 0 0 0-.926.654L5.015 4.55a.364.364 0 0 1-.33.196H1.31c-.463 0-.794.262-.926.655s0 .85.33 1.112l2.714 1.964c.132.065.132.262.132.392L2.501 12.01c-.132.393 0 .85.331 1.112.331.262.794.262 1.191 0l2.713-1.963a.426.426 0 0 1 .397 0l2.713 1.963c.199.131.397.197.596.197.198 0 .397-.066.595-.197.331-.261.463-.654.331-1.112L10.31 8.868c-.066-.13 0-.261.133-.392l2.713-1.964c.463-.196.595-.654.463-1.047Z"
      fill="#FFA800"
    />
  </svg>
)

export default SvgYellowStar
